module.exports = __webpack_public_path__ + "static/media/zapsplat_office_pen_biro_ball_point_tap_002_49693.acc378a1.wav";